// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"cb704710","121":"cc835df3","130":"5e1606f8","569":"52032ac1","638":"294cc775","843":"2e7f62eb","852":"3efd5dfb","855":"489afcf3","885":"05b489e8"}[chunkId] + ".chunk.js";
};